import { gql } from 'graphql-request';

export default gql`
  query Conferences($filters: JSON) {
    conferences(filters: $filters) {
      totalCount
    }
  }
`;
